// import allUsers from "./slice/all-users";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import pastDate from "./slice/pastDate";
import holdingList from "./slice/holdingList";
import deliveryData from "./slice/deliveryData";
import deliveryDate from "./slice/deliveryDate";
import userToken from "./slice/userToken";
import panchangUpdate from "./slice/panchangUpdate";
// import storageSession from 'redux-persist/lib/storage/session';

import { createTransform } from 'redux-persist';
import LZString from 'lz-string';

const compressTransform = createTransform(
  (inboundState) => {
    // before storing: stringify + compress
    try {
      const str = JSON.stringify(inboundState);
      return LZString.compressToUTF16(str);
    } catch (e) { return inboundState; }
  },
  (outbound) => {
    // on rehydrate: decompress + parse
    try {
      const str = LZString.decompressFromUTF16(outbound);
      return JSON.parse(str);
    } catch (e) { return outbound; }
  }
);




const rootReducer = combineReducers({
  pastDate:pastDate,
  holdingList:holdingList,
  deliveryData: deliveryData,
  deliveryDate: deliveryDate,
  userToken: userToken,
  panchangUpdate:panchangUpdate
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [compressTransform],
  // storage: storageSession,
  // whitelist: ['auth', 'userPrefs'], // only keep what you need
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, 
      serializableCheck: false, // 
    }),
    devTools: process.env.NODE_ENV !== "production",

});

export const persistor = persistStore(store);